import { ThemeUIStyleObject } from 'theme-ui';

export const sectionStyles: ThemeUIStyleObject = {
  marginBottom: ['1rem', '2rem'], // mobile, desktop
  overflow: 'hidden',
};

export const cardStyles: ThemeUIStyleObject = {
  cursor: 'pointer',
  '&:hover': {
    boxShadow: 'large',
  },
};
